import { useState, createContext, useContext } from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { useAuth } from '@/lib/auth-context';
import { Navigate } from 'react-router-dom';
import { Skeleton } from '@/components/ui/skeleton';

const SidebarContext = createContext();
export const useSidebar = () => useContext(SidebarContext);

export function DashboardLayout({ children, title = 'Panel' }) {
  const { isAuthenticated, loading } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen bg-[hsl(var(--background))] flex items-center justify-center">
        <div className="space-y-4 w-64">
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <SidebarContext.Provider value={{ mobileOpen, setMobileOpen }}>
      <div className="min-h-screen bg-[hsl(var(--background))]">
        {/* Mobile backdrop */}
        {mobileOpen && (
          <div
            className="fixed inset-0 bg-black/50 z-40 lg:hidden"
            onClick={() => setMobileOpen(false)}
          />
        )}

        <Sidebar onMobileClose={() => setMobileOpen(false)} mobileOpen={mobileOpen} />

        <div className="lg:ml-[240px] min-h-screen transition-[margin] duration-200">
          <TopBar title={title} onMenuToggle={() => setMobileOpen(!mobileOpen)} />
          <main className="p-4 sm:p-6">
            {children}
          </main>
        </div>
      </div>
    </SidebarContext.Provider>
  );
}
